module.exports = __webpack_public_path__ + "img/foodlevel.ff9ae50d.svg";